import React from "react"

import Privacy from "../components/Privacy/privacy"
import Layout from "../components/layout"

export default () => (
  <Layout>
    <Privacy />
  </Layout>
)
